import React from 'react';
import styled from 'styled-components';

const StyledIllustration = styled('svg')(() => ({
  width: '120%',
  position: 'absolute',
  bottom: '-13%',
  left: '-10%',
  zIndex: 0
}));

const PricingGreenWave = () => {
  return (
    <StyledIllustration viewBox="0 0 1822.49 371.94">
      <defs>
        <linearGradient
          id="prefix__pricing-green-wavea"
          x1={1173.86}
          y1={0.74}
          x2={1173.86}
          y2={1.74}
          gradientTransform="matrix(1822.58 0 0 372.02 -2138532.27 -276)"
          gradientUnits="userSpaceOnUse">
          <stop offset={0} stopColor="#21bc90" />
          <stop offset={1} stopColor="#35dbac" />
        </linearGradient>
      </defs>
      <path
        d="M183.4 102.8c350.4 301.7 1044 85.5 1326.6-29s139.5 72.8 222.9 72.8c32.1 0 67.6 98.7 89.6 225.8H84.8c-17.7-171.6-232.5-554.7 98.6-269.6z"
        transform="translate(-.01 -.46)"
        fillRule="evenodd"
        fill="url(#prefix__pricing-green-wavea)"
      />
    </StyledIllustration>
  );
};
export default PricingGreenWave;
